import { useMediaQuery } from "@mui/material";
import DefaultButton from "../../../../../..//components/buttons/default-button";
import homeFullBanner from "../../../../../../assets/images/home_full.png";
import homeMobileBanner from "../../../../../../assets/images/home_full_mobile.png";
import DefaultText from "../../../../../../components/typography/default-text";
import styles from "./styles.module.css";
import { sxTextHomeBanner } from "./sxProps";
import { useNavigate } from "react-router-dom";

const HomeBanner = () => {
  const navigate = useNavigate();

  const vw1280px = useMediaQuery("(max-width: 1280px)");

  return (
    <div
      className={
        vw1280px
          ? styles["home-banner-container-mobile"]
          : styles["home-banner-container"]
      }
    >
      <div className={styles["home-banner"]}>
        <div>
          <DefaultText
            zIndex={1}
            color={vw1280px ? "var(--primary-blue)" : "var(--primary-white)"}
            size={"medium"}
            sx={{ fontFamily: "Montserrat-Bold" }}
          >
            <i>Há 51 anos</i>
          </DefaultText>
          <DefaultText
            zIndex={1}
            color={vw1280px ? "var(--primary-blue)" : "var(--primary-white)"}
            lineHeight={vw1280px ? "32px" : "48px"}
            size={"medium"}
            sx={{ fontFamily: "Montserrat-Bold" }}
          >
            transformando vidas e <br /> impulsionando futuros.
          </DefaultText>
        </div>
        <DefaultText
          zIndex={1}
          color={vw1280px ? "var(--primary-blue)" : "var(--primary-white)"}
          size={"small"}
          sx={sxTextHomeBanner}
        >
          <b>Na TELEMONT,</b> sabemos que o nosso trabalho faz a diferença e
          impacta diretamente a sua vida. Por isso, estamos comprometidos em
          oferecer sempre o melhor em serviços de telecomunicações e energia
          para pessoas e organizações.
        </DefaultText>
        <DefaultButton
          variant={vw1280px ? "contained" : "outlined"}
          onClick={() => navigate("/empresa/sobre-nos")}
        >
          Saiba Mais
        </DefaultButton>
      </div>
      <img
        src={vw1280px ? homeMobileBanner : homeFullBanner}
        className={
          vw1280px
            ? styles["home-banner-image-mobile"]
            : styles["home-banner-image"]
        }
        alt="Imagem de homem com capacete de obras"
      />
    </div>
  );
};

export default HomeBanner;
